export default new (function () {
  this.field = {
    getValue: () => {
      console.info('Amplience SDK: getValue')
      return {
        site: 'UK',
        facet: 'sortBy',
        values: [],
      }
    },
    setValue: (value) => {
      console.info('Amplience SDK: setValue:', value)
    },
  }

  this.frame = {
    startAutoResizer: () => {
      console.info('Amplience SDK: startAutoResizer')
    },
  }

  this.form = {
    readOnly: false,
  }

  this.params = {
    instance: {
      appId: process.env.REACT_APP_AQS_APP_ID || 'test-app-id',
      apiKey: process.env.REACT_APP_AQS_APP_KEY || 'test-api-key',
      indexBySite: {
        UK: 'dev_product_uk',
        IE: 'dev_product_ie',
      },
      sortConfigBySite: {
        UK: {
          defaultRefinement: 'dev_product_uk',
          items: [
            { value: 'dev_product_uk', label: 'Default ranking' },
            { value: 'dev_product_uk_price_asc', label: 'Price low - high' },
            { value: 'dev_product_uk_price_desc', label: 'Price high - low' },
          ],
        },
        IE: {
          defaultRefinement: 'dev_product_ie',
          items: [
            { value: 'dev_product_ie', label: 'Default ranking' },
            { value: 'dev_product_ie_price_asc', label: 'Price low - high' },
            { value: 'dev_product_ie_price_desc', label: 'Price high - low' },
          ],
        },
      },
      facets: [
        { name: 'Sort by', attribute: 'sortBy', component: 'sort' },
        { name: 'Arrangement type', attribute: 'arrangementType', component: 'terms' },
        { name: 'Price', attribute: 'price', component: 'price' },
      ],
      currency: 'GBP',
    },
    installation: {},
  }
})()
